import { NewsCategory, NewsStatus, SimpleNews } from '@/grpc/client/bpt/hall/news/v1/news'
import { newsMgr } from '@/grpc/domain/hall/news'
import { MMDDHHmm } from '@/utils/time'
import { mttTimeFormat, YYYYMMDDHHmm } from '@/utils/time'
import dayjs from 'dayjs'

import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { makeAutoObservable, runInAction } from 'mobx'


dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)  


export const getTimeStr = (time: string, isNeedYear: boolean = true) => {
  const timeNum = Number(time)
  const currTime = dayjs()
  const diffSecond = currTime.diff(timeNum, 'second')
  const diffMinute = currTime.diff(timeNum, 'minute')
  const diffHour = currTime.diff(timeNum, 'hour')
  const diff = currTime.diff(timeNum, 'minute')

  // 标题下方展示发布时间：
  // 1分钟内显示：“刚刚”；
  // 1-60分钟内则显示：X分钟前；
  // 24小时内则显示：X小时前；
  // 超过24小时则显示具体的日月时分；
  if (diffSecond < 60) {
    //一分钟内
    return 'Just Now'
  } else if (diffMinute < 60) {
    return `${diffMinute} minutes ago`
  } else if (diffHour < 24) {
    // 24 小时内
    return `${diffHour} hours ago`
  }
  const formatStr = isNeedYear ? YYYYMMDDHHmm : MMDDHHmm
  return mttTimeFormat(timeNum, formatStr)
}

export const getDetailTimeStr = (time: string) => {
  const timeNum = dayjs(time)
  return mttTimeFormat(timeNum, YYYYMMDDHHmm)
}

export interface INewsItem {
  /** 新闻ID */
  id: string
  /** 新闻标题 */
  newsTitle: string
  /** 新闻封面/缩略图 */
  mainImage: string
  /** 摘要 */
  abstract: string
  /** 跳转链接 */
  jumpLink: string
  /** pc banner 图片 */
  pcBannerImage: string
  /** 移动 banner 图片 */
  mobileBannerImage: string
  /** 时间描述 */
  publicTimeDesc: string

}

interface IApiResult {
  /** 是否成功或失败 */
  success: boolean
  /** 具体数据 */
  data: INewsItem[]
  /** 分页属性 */
  meta: {
    /** 总条数 */
    total: number
    /** 最后一页的数量 */
    lastPage: number
    /** 当前页码 */
    currentPage: number
    /** 每页 多少 条 */
    perPage: number
    prev: null
    next: number
  }
  unreadNewsCount: number
}

export const newItemToV1Item = (item: SimpleNews): INewsItem => {
  return {
    ...item,
    newsTitle: item.i18nTitle || item.title,
    mainImage: item.coverImages?.at(0) || item.mainImg,
    abstract: item.abstract,
    jumpLink: item.jumpLink,
    pcBannerImage: item.pcBannerImage,
    mobileBannerImage: item.mobileBannerImage,
    publicTimeDesc: getTimeStr((item.updatedAt || item.createdAt).toString()),
  }
}
/**
 * 新闻 Store
 * 列表数据在列表页面使用 useInfiniteQuery 维护
 * 此处维护跨组件的 scroll, entered, tab, unread 状态
 */
export class NewsStore {
  private queryStamp: number = 0
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  /** 当前滚动条的位置 */
  scrollTop: number = 0
  category: string = NewsCategory.NewsCategoryAll.toString()

  /** 设置当前滚动条的位置 */
  setScrollTop = (scrollTop: number) => {
    this.scrollTop = scrollTop
  }

}

export const newsState = new NewsStore()

